import React, { useEffect, useState, useRef } from 'react';
import { InView } from 'react-intersection-observer';
import clsx from 'clsx';
import { observer } from 'mobx-react';

import { stories } from '../../../content/Stories';

import classes from './sectionContent.module.scss';

import { analytics, AnalyticsShow } from '@/utils/analytics';
import { TagList } from '@/components/UI/TagList/TagList';
import { Story } from '@/components/Story/Story';
import { useStorage } from '@/models/Storage';

export const SectionContent = observer(({ likes }) => {
    const { selectedTags } = useStorage();

    const [filteredIds, setFilteredIds] = useState([]);
    let bottomPixelShow = false;

    useEffect(() => {
        const matchingIds = [];
        stories.forEach((story) => {
            const intersection = selectedTags.filter((element) => story.tags.includes(element));
            if (intersection.length > 0 && !matchingIds.includes(story.id)) {
                matchingIds.push(story.id);
            }
        });
        setFilteredIds(matchingIds);
    }, [selectedTags.length]);

    return (
        <section className={classes.content}>
            <div className={clsx('container', classes.container)}>
                <TagList isTarget />
                {selectedTags.length > 0 ? (
                    <>
                        {filteredIds.length !== 0 ? (
                            <div className={classes.stories}>
                                {stories.map((story) => {
                                    if (filteredIds.includes(story.id)) {
                                        return (
                                            <Story
                                                key={story.id}
                                                {...story}
                                                likes={likes ? likes[story.id] : 0}
                                            />
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                        ) : (
                            <div className={classes.placeholder}>
                                <span>Истории не найдены</span>
                            </div>
                        )}
                        {filteredIds.length !== stories.length && (
                            <>
                                <div className={classes.divider}>другое</div>
                                <div className={classes.stories}>
                                    {stories.map((story) => {
                                        if (!filteredIds.includes(story.id)) {
                                            return (
                                                <Story
                                                    key={story.id}
                                                    {...story}
                                                    likes={likes ? likes[story.id] : 0}
                                                />
                                            );
                                        }
                                        return null;
                                    })}
                                </div>
                            </>
                        )}
                    </>
                ) : (
                    <div className={classes.stories}>
                        {stories.map((story) => {
                            return (
                                <Story
                                    key={story.id}
                                    {...story}
                                    likes={likes ? likes[story.id] : 0}
                                />
                            );
                        })}
                    </div>
                )}
                <InView
                    as="div"
                    onChange={(inView, entry) => {
                        if (inView && !bottomPixelShow) {
                            analytics(AnalyticsShow.ScrollBottom);
                            bottomPixelShow = true;
                        }
                    }}
                ></InView>
            </div>
        </section>
    );
});
